function asText(value) {
  if (value == null) return null;
  const text = String(value).trim();
  return text || null;
}

function isHttpUrl(url) {
  if (!url) return false;
  return /^https?:\/\//i.test(url) || url.startsWith("//");
}

function normalizeUrl(url) {
  const raw = asText(url);
  if (!raw) return null;
  if (raw.startsWith("//")) return `https:${raw}`;
  if (!isHttpUrl(raw)) return null;
  return raw;
}

function pushCandidate(out, value) {
  if (!value) return;
  const normalized = normalizeUrl(value);
  if (!normalized) return;
  if (!out.includes(normalized)) out.push(normalized);
}

function collectFromUnknown(out, value) {
  if (value == null) return;
  if (typeof value === "string") {
    pushCandidate(out, value);
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((item) => collectFromUnknown(out, item));
    return;
  }
  if (typeof value !== "object") return;
  pushCandidate(out, value.url);
  pushCandidate(out, value.URL);
  pushCandidate(out, value.href);
  pushCandidate(out, value.image);
  pushCandidate(out, value.Image);
  pushCandidate(out, value.imageUrl);
  pushCandidate(out, value.ImageUrl);
  pushCandidate(out, value.mainImage);
  pushCandidate(out, value.MainImage);
  pushCandidate(out, value.Picture);
  pushCandidate(out, value.picture);
  pushCandidate(out, value.HotelPicture);
  pushCandidate(out, value.resourceUrl);
  pushCandidate(out, value.ResourceUrl);
}

function collectEntityImages(entity) {
  const out = [];
  if (!entity || typeof entity !== "object") return out;
  collectFromUnknown(out, entity.mainImage);
  collectFromUnknown(out, entity.MainImage);
  collectFromUnknown(out, entity.Picture);
  collectFromUnknown(out, entity.picture);
  collectFromUnknown(out, entity.image);
  collectFromUnknown(out, entity.imageUrl);
  collectFromUnknown(out, entity.HotelPicture);
  collectFromUnknown(out, entity.resourceUrl);
  collectFromUnknown(out, entity.resources);
  collectFromUnknown(out, entity.resource);
  collectFromUnknown(out, entity.images);
  collectFromUnknown(out, entity.Images);
  collectFromUnknown(out, entity.galleryImages);
  collectFromUnknown(out, entity.DefaultImage);
  return out;
}

export function buildPublicHotelImageBundle({
  selectedHotel = null,
  selectedRoom = null,
  selectedPackage = null,
  galleryImages = null,
  hotelImage = null,
  roomImage = null,
} = {}) {
  const roomImages = collectEntityImages(selectedRoom);
  const hotelImages = collectEntityImages(selectedHotel);
  const packageImages = collectEntityImages(selectedPackage);

  const hotelGallery = [];
  collectFromUnknown(hotelGallery, galleryImages);
  collectFromUnknown(hotelGallery, selectedHotel?.galleryImages);
  collectFromUnknown(hotelGallery, selectedPackage?.galleryImages);
  collectFromUnknown(hotelGallery, selectedHotel?.images);
  collectFromUnknown(hotelGallery, selectedPackage?.images);

  const roomGallery = [];
  collectFromUnknown(roomGallery, selectedRoom?.galleryImages);
  collectFromUnknown(roomGallery, selectedRoom?.images);
  collectFromUnknown(roomGallery, selectedRoom?.media);

  const explicitRoomImage = normalizeUrl(roomImage) || roomImages[0] || null;
  const explicitHotelImage =
    normalizeUrl(hotelImage) || hotelImages[0] || packageImages[0] || null;
  const dedupedHotelGallery = [...new Set(hotelGallery)];
  const dedupedRoomGallery = [...new Set(roomGallery)];
  const dedupedGallery = [...new Set([...dedupedHotelGallery, ...dedupedRoomGallery])];

  return {
    roomImage: explicitRoomImage,
    hotelImage: explicitHotelImage,
    galleryImages: dedupedGallery,
    hotelGalleryImages: dedupedHotelGallery,
    roomGalleryImages: dedupedRoomGallery,
  };
}

